import { Box, Link, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import Typography from "components/basic/typography";
import { PolicySection } from "../../content";

/**
 * Plain anchor links rather than router navigation — these target ids on this
 * same page, and a router push would remount it and lose the scroll position.
 */
const TableOfContents: React.FC<{ sections: PolicySection[] }> = ({
  sections,
}) => {
  const { t } = useTranslation("legal");

  return (
    <Paper
      variant="outlined"
      sx={{ padding: 2, borderRadius: 2, marginBottom: 5 }}
    >
      <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
        {t("common.contents")}
      </Typography>

      <Box
        component="ul"
        sx={{
          margin: 0,
          marginTop: 1,
          paddingLeft: 2.5,
          columns: { xs: 1, md: 2 },
        }}
      >
        {sections.map((section) => (
          <Box component="li" key={section.id} sx={{ marginBottom: 0.75 }}>
            <Link href={`#${section.id}`} underline="hover">
              {section.title}
            </Link>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default TableOfContents;
